export default "__VITE_ASSET__B$ajRC5K__"